/* eslint-disable */
/*eslint-disable*/
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Autocomplete from "@mui/material/Autocomplete";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  CircularProgress,
  Collapse
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import {
  features,
  language,
  otc,
  prescription as prescript,
  condition,
  countries,
  default_country_code,
} from "config";

import DocumentScanner from "../../components/DocumentScanner";
import FileUploader from "components/FileUploader";

const useStyles = makeStyles((theme) => ({
  collapsibleContainer: {
    backgroundColor: "#f9f9f9",
    padding: theme.spacing(2),
    borderRadius: "4px",
    marginTop: theme.spacing(1),
    border: "1px solid #ddd"
  },
  collapsibleField: {
    marginBottom: theme.spacing(1.5),
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#bbb"
      },
      "&:hover fieldset": {
        borderColor: "#888"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  expandIcon: {
    transition: "transform 0.3s ease"
  },
  expandedIcon: {
    transform: "rotate(180deg)"
  },
  AddUserTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#009ad8",
    color: "#fff",
    padding: "16px",
    borderRadius: "4px 4px 0 0",
    fontSize: "18px",
    fontWeight: "bold"
  },
  selectField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "10px 12px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  userTypeField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    border: "1px solid #ccc",
    padding: "10px 12px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc"
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  saveButton: {
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#009ad8",
    "&:hover": {
      backgroundColor: "#2c6e31"
    }
  },
  closeButton: {
    backgroundColor: "#009ad8",
    color: "#fff",
    textTransform: "none",
    "&:disabled": {
      backgroundColor: "#cccccc",
      color: "#666666"
    }
  },
  dialogContent: {
    backgroundColor: "#fafafa",
    padding: "20px"
  },
  formControl: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
   textFieldNotes: {
    border: "1px solid #ccc",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    "& .MuiInputBase-input": {
      padding: "12px"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc",
        borderTopWidth: "2px"  // thicker top border for visibility
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  textField: {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    "& .MuiInputBase-input": {
      padding: "12px"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc",
        borderTopWidth: "2px"  // thicker top border for visibility
      },
      "&:hover fieldset": {
        borderColor: "#999"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#009ad8"
      }
    }
  },
  dialogActions: {
    padding: "16px",
    justifyContent: "space-between"
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "6px",
    display: "block",
    transition: "0.2s ease all"
  },
  floatingLabel: {
    transform: "translate(14px, -12px) scale(0.75)",
    backgroundColor: "#ffffff",
    padding: "0 4px",
    color: "#009ad8"
  },
  formHelperText: {
    fontSize: "12px",
    color: "#d32f2f"
  },
  input: {
    fontSize: "14px",
    padding: "10px 12px"
  },
  inputField: {
    marginBottom: theme.spacing(1.5)
  }
}));

// Helper function for date formatting dd/MM/yy
const formatDateDDMMYY = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d)) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = String(d.getFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
};

const FormComponent = ({
  data = {},
  columns = [],
  modalType,
  onClose,
  onSubmit
}) => {

  const classes = useStyles();
  const auth = useSelector((state) => state.auth);
  const specialities = useSelector((state) => state.specialitytypes.specialities);
  const [specialityTypes, setSpecialityTypes] = useState({});
  const [addressExpanded, setAddressExpanded] = useState(false);
  const [otcT, setotcT] = useState([]);
  const [prescripts, setprescripts] = useState([]);
  const [conditions, setconditions] = useState([]);
  const [consentFormFile, setConsentFormFile] = useState(null);
  const doctortypes = useSelector((state) => state.doctortypes.doctortypes);

  const [addressFields, setAddressFields] = useState({
    street: "",
    city: "",
    state: "",
    zipCode: ""
  });

  const [countryCode, setCountryCode] = useState(
    "+" + default_country_code.phone
  );
  const [doctorTypes, setDoctorTypes] = useState([]);

  const formatCountries = () => {
    return countries.map((country) => ({
      label: `${country.label} (+${country.phone})`,
      value: `+${country.phone}`,
      key: country.code
    }));
  };

  const flattenColumns = (cols) => {
    const flat = [];
    cols.forEach((col) => {
      if (col.id === "TenantDetails") {
        flat.push(...flattenColumns(col.columns));
      } else {
        flat.push(col);
      }
    });
    return flat;
  };

  const flattenedColumns = flattenColumns(columns);

  const getNestedValue = (obj, path) => {
    if (!path || path === "username") return;
    return path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);
  };

  const setNestedValue = (obj, path, value) => {
    const keys = path.split(".");
    const lastKey = keys.pop();
    const nestedObj = keys.reduce((acc, key) => {
      if (!acc[key]) acc[key] = {};
      return acc[key];
    }, obj);
    nestedObj[lastKey] = value;
  };

  const initialFields = flattenedColumns
    .filter(
      (field) =>
        !field.enableHiding &&
        field.accessorKey &&
        field.accessorKey.toLowerCase() !== "username" &&
        field.accessorKey.toLowerCase() !== "id"
    )
    .map((field) => ({
      ...field,
      value:
        modalType === "edit"
          ? getNestedValue(data, field.accessorKey) || ""
          : "",
      isEditable: field.enableEditing !== false
    }));

  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  const handleInputChange = (accessorKey, value) => {
    setFields((prevFields) =>
      prevFields.map((field) =>
        field.accessorKey === accessorKey ? { ...field, value } : field
      )
    );
  };

  useEffect(() => {
    if (modalType === "edit" && data.address) {
      const parts = data.address.split(",").map((part) => part.trim());
      setAddressFields({
        street: parts[0] || "",
        city: parts[1] || "",
        state: parts[2] || "",
        zipCode: parts[3] || ""
      });
    }
  }, [data, modalType]);

  useEffect(() => {
    if (otc) {
      const arr = {};
      otc.forEach((o) => (arr[o.concept_name] = o.concept_name));
      setotcT(Object.values(arr));
    }
    if (prescript) {
      const arr = {};
      prescript.forEach((p) => (arr[p.concept_name] = p.concept_name));
      setprescripts(Object.values(arr));
    }
    if (condition) {
      const arr = {};
      condition.forEach((c) => (arr[c.concept_name] = c.concept_name));
      setconditions(Object.values(arr));
    }
  }, []);

  useEffect(() => {
    if (doctortypes && Array.isArray(doctortypes)) {
      setDoctorTypes(doctortypes);
    }
  }, [doctortypes]);

  useEffect(() => {
    if (specialities && Array.isArray(specialities)) {
      setSpecialityTypes(specialities);
    }
  }, [specialities]);

  const handleSubmit = () => {
    const changedData = {};
    const physicalAddress = `${addressFields.street}, ${addressFields.city}, ${addressFields.state}, ${addressFields.zipCode}`;
    if (physicalAddress && physicalAddress.replace(/[\s,]+/g, "").trim() !== "") {
      changedData.address = physicalAddress;
    }

    fields.forEach((field) => {
      const originalValue = data
        ? (getNestedValue(data, field.accessorKey) || "").toString()
        : "";
      if (field.value.toString() !== originalValue) {
        changedData[field.accessorKey] = field.value;
      }
    });

    const phoneField = fields.find((field) => field.accessorKey === "phone");
    if (phoneField) {
      let phoneValue = phoneField.value.trim();
      if (!phoneValue.startsWith(countryCode)) {
        phoneValue = countryCode + phoneValue;
      }
      if (!data || phoneValue !== data.phone) {
        changedData.phone = phoneValue;
      }
    }

    const mobileField = fields.find((field) => field.accessorKey === "mobile");
    if (mobileField) {
      let mobileValue = mobileField.value.trim();
      if (!mobileValue.startsWith(countryCode)) {
        mobileValue = countryCode + mobileValue;
      }
      if (!data || mobileValue !== data.mobile) {
        changedData.mobile = mobileValue;
      }
    }

    if (consentFormFile) {
      changedData.consentForm = consentFormFile;
    }

    const updatedData = { ...data, ...changedData };
    onSubmit(updatedData);
    onClose();
  };

  const handleAddressChange = (field, value) => {
    setAddressFields((prev) => ({ ...prev, [field]: value }));
  };

  const toggleAddress = () => {
    setAddressExpanded(!addressExpanded);
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={classes.AddUserTitle}>
        {modalType === "edit" ? "Edit " : "Add "}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {fields.some((field) => field.accessorKey === "address") && (
          <>
            <Button
              onClick={toggleAddress}
              fullWidth
              variant="contained"
              style={{
                marginBottom: "10px",
                backgroundColor: "#f1f1f1",
                textAlign: "left",
                padding: "10px"
              }}
            >
              Address Details
            </Button>
            <Collapse
              in={addressExpanded}
              className={classes.collapsibleContainer}
              style={{ border: "1px solid #ddd", padding: "10px" }}
            >
              <TextField
                label="Street"
                value={addressFields.street}
                onChange={(e) => handleAddressChange("street", e.target.value)}
                variant="outlined"
                fullWidth
                className={classes.textField}
                style={{ marginBottom: "12px" }}
              />
              <TextField
                label="City"
                value={addressFields.city}
                onChange={(e) => handleAddressChange("city", e.target.value)}
                variant="outlined"
                fullWidth
                className={classes.textField}
                style={{ marginBottom: "12px" }}
              />
              <TextField
                label="State"
                value={addressFields.state}
                onChange={(e) => handleAddressChange("state", e.target.value)}
                variant="outlined"
                fullWidth
                className={classes.textField}
                style={{ marginBottom: "12px" }}
              />
              <TextField
                label="Zip Code"
                value={addressFields.zipCode}
                onChange={(e) => handleAddressChange("zipCode", e.target.value)}
                variant="outlined"
                fullWidth
                className={classes.textField}
                style={{ marginBottom: "12px" }}
              />
            </Collapse>
          </>
        )}

        {["drug_concept_id", "drug_source_value", "route_source_value", "devicetype", "doctorTypes", "specialityTypes"].map((key) => {
          let options = [];

          if (key === "drug_concept_id") {
            options = otcT;
          } else if (key === "drug_source_value") {
            options = prescripts;
          } else if (key === "route_source_value") {
            options = conditions;
          } else if (key === "devicetype") {
            options = ["ALL", "ANDROID", "IOS"];
          } else if (key === "doctorTypes") {
            options = doctorTypes;
          }
          else if (key === "specialityTypes") {
            options = specialityTypes;
          }

          return fields.some((field) => field.accessorKey === key) ? (
            <Autocomplete
              key={key}
              multiple
              freeSolo
              options={Array.isArray(options) ? options : ["No option"]}
              value={fields.find((field) => field.accessorKey === key)?.value || []}
              onChange={(_, newValue) => handleInputChange(key, newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={key.replaceAll("_", " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                  variant="outlined"
                  fullWidth
                  className={classes.textField}
                />
              )}
              className={classes.formControl}
            />
          ) : null;
        })}

        {fields.some((field) => field.accessorKey === "consentForm") && (
          <div className={classes.formControl}>
            <label className={classes.label}>Consent Form Upload</label>
            <FileUploader
              onFileSelect={(file) => setConsentFormFile(file)}
              acceptedTypes={["application/pdf", "image/*"]}
            />
          </div>
        )}

        {fields.some((field) => field.accessorKey === "uploadDocument") && (
          <div className={classes.formControl}>
            <label className={classes.label}>Document Upload</label>
            <FileUploader
              onFileSelect={(file) => setConsentFormFile(file)}
              acceptedTypes={["application/pdf", "image/*"]}
            />
          </div>
        )}

      {fields.some((field) => field.accessorKey === "note_text") && (
  <TextField
    label="Note"
    variant="outlined"
    name="note_text"
    fullWidth
    multiline
    minRows={2}
    maxRows={8}
    className={classes.textFieldNotes} // ✅ correct style
    style={{ marginBottom: 8 }}         // ✅ fix casing
    value={fields.find((field) => field.accessorKey === "note_text")?.value || ""}
    onChange={(e) => handleInputChange("note_text", e.target.value)}
    InputProps={{
      style: { overflowY: "auto" }
    }}
  />
)}

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {fields
            .filter(
              (field) =>
                ![
                  "address",
                  "devicetype",
                  "drug_concept_id",
                  "doctorTypes",
                  "route_source_value",
                  "person_id",
                  "drug_source_value",
                  "userType",
                  "specialityTypes",
                  "note_text",
                  "consentForm",
                  "uploadDocument"
                ].includes(field.accessorKey)
            )
            .map((field) => (
              <FormControl
                key={field.accessorKey}
                className={classes.formControl}
                error={Boolean(errors[field.accessorKey])}
                fullWidth
              >
                {(field.accessorKey === "mobile" || field.accessorKey === "phone") && (
                  <>
                    <InputLabel className={classes.label}>Country</InputLabel>
                    <Select
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                      className={classes.inputField}
                    >
                      {formatCountries().map((country) => (
                        <MenuItem key={country.key} value={country.value}>
                          {country.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                )}

                {field.type === "date" ? (
                  <DatePicker
                    label={field.header}
                    value={field.value ? new Date(field.value) : null}
                    onChange={(newValue) => {
                      handleInputChange(
                        field.accessorKey,
                        newValue ? formatDateDDMMYY(newValue) : ""
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        className={classes.textField}
                        error={Boolean(errors[field.accessorKey])}
                        helperText={errors[field.accessorKey]}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                ) : (
                  <TextField
                    label={field.header}
                    variant="outlined"
                    name={field.accessorKey}
                    value={field.value}
                    onChange={(e) =>
                      handleInputChange(field.accessorKey, e.target.value)
                    }
                    error={Boolean(errors[field.accessorKey])}
                    helperText={errors[field.accessorKey]}
                    className={classes.textField}
                    fullWidth
                    multiline={field.multiline}
                    minRows={field.minRows}
                    maxRows={field.maxRows}
                  />
                )}
              </FormControl>
            ))}
        </LocalizationProvider>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          className={classes.saveButton}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={24} /> : "Save"}
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          className={classes.closeButton}
          disabled={isLoading}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FormComponent.propTypes = {
  data: PropTypes.object,
  columns: PropTypes.array,
  modalType: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default FormComponent;
